import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

const configureRoutes = (routes: RoutesService) => () => {
  routes.add([
    {
      path: '/projects',
      iconClass: 'fa fa-file-alt',
      order: 1,
      name: '::Menu:Projects',
      layout: eLayoutType.application,
      requiredPolicy: 'SestekAI.Projects',
    },
  ]);
};

export const PROJECTS_PROJECT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];
